import React, { useState, useEffect, useRef } from 'react'
import './Recenze.scss'

const ReviewsSection = () => {
  const [currentReview, setCurrentReview] = useState(0)
  const [isVisible, setIsVisible] = useState(false)
  const [isPaused, setIsPaused] = useState(false)
  const sectionRef = useRef(null)
  const intervalRef = useRef(null)

  const reviews = [
    { 
      name: 'Adam Profota', 
      rating: 5, 
      text: 'Lepší autoškolu jsem si vybrat nemohl. Pan Příkaský vše jasně a srozumitelně vysvětlí, nezvyšuje hlas, i když bych řekl, že to bylo párkrát potřeba. Jako obrovské plus je i to, že si pro vás přijede a ať už po teoriích či jízdách vás opět zaveze zpět domů. Autoškola pana Příkaského naplno splnila veškerá moje očekávání a kurz jsem měl hotový během měsíce a půl, a proto mi nezbývá nic jiného, než dát 5⭐',
      initials: 'AP',
      course: 'Základní kurz'
    },
    { 
      name: 'mich.k', 
      rating: 5, 
      text: 'Neváhejte :)) Pan Příkaský je hodný, klidný, trpělivý a ochotný a takové lidi není lehké najít. Moc mu děkuji, že mě perfektně připravil. Nemám jedinou věc, co bych vytkla. Lepší autoškolu jsem si zvolit nemohla.',
      initials: 'MK',
      course: 'Základní kurz'
    },
    { 
      name: 'Aneta Fialová', 
      rating: 5, 
      text: 'Pan Příkaský je člověk na správném místě. Velmi trpělivý a hodný, vždy se snažil vše pěkně vysvětlit a ani jednou na mě nezvedl hlas, i když to určitě několikrát bylo na místě. Jako velkou výhodu vidím to, že se s ním dá domluvit na místě začátku jízdy i jejím ukončení, dokonce i na praktickou výuku si pro vás přijede a nemusíte nikam dojíždět.',
      initials: 'AF',
      course: 'Základní kurz'
    },
    { 
      name: 'Iveta Blahová', 
      rating: 5, 
      text: 'Výborná příprava na závěrečné zkoušky, hodný pan Příkaský, který vše s klidem vysvětlí a poradí.',
      initials: 'IB',
      course: 'Základní kurz'
    },
    { 
      name: 'Vít Gerych', 
      rating: 5, 
      text: 'Velice profesionální a přátelský přístup Pana instruktora. Řidičský průkaz za krátkou dobu a bez žádných komplikací na straně autoškoly.',
      initials: 'VG',
      course: 'Expresní kurz'
    },
    { 
      name: 'Hana Horká', 
      rating: 5, 
      text: 'Moc bych chtěla poděkovat panu Příkasskému za skvělou přípravu na zkoušky. Můžu vřele doporučit!!',
      initials: 'HH',
      course: 'Základní kurz'
    },
    { 
      name: 'Markéta Lah', 
      rating: 5, 
      text: 'Skvělý a velmi trpělivý instruktor, který vše velmi dobře vysvětlí a skvěle Vás na řízení i zkoušku připraví. Doporučuji 10/10',
      initials: 'ML',
      course: 'Základní kurz'
    }
  ]

  const handleContactClick = () => {
    const element = document.getElementById('kontakt')
    if (element) {
      const headerHeight = window.innerWidth < 768 ? 80 : 100
      const elementPosition = element.offsetTop
      const offsetPosition = elementPosition - headerHeight

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        }
      },
      { threshold: 0.2 }
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setCurrentReview(prev => (prev + 1) % reviews.length)
      }, 6000) // Auto-switch každých 6 sekund
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [isPaused, reviews.length])

  const handleReviewSelect = (index) => {
    setCurrentReview(index)
    setIsPaused(true)
    
    // Resume auto-play after 10 seconds
    setTimeout(() => setIsPaused(false), 10000)
  }

  const nextReview = () => {
    setCurrentReview(prev => (prev + 1) % reviews.length)
    setIsPaused(true)
    setTimeout(() => setIsPaused(false), 10000)
  }

  const prevReview = () => {
    setCurrentReview(prev => (prev - 1 + reviews.length) % reviews.length)
    setIsPaused(true)
    setTimeout(() => setIsPaused(false), 10000)
  }

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
        ⭐
      </span>
    ))
  }

  const averageRating = reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length
  const totalReviews = reviews.length

  return (
    <div className={`reviews-section ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
      <div className="section-content">
        <div className="reviews-header">
          <h2>Co říkají naši absolventi</h2>
          <p>Přečtěte si skutečné recenze od našich úspěšných studentů</p>
          
          <div className="reviews-stats">
            <div className="stat-item">
              <div className="stat-number">{averageRating.toFixed(1)}</div>
              <div className="stat-stars">
                {renderStars(Math.round(averageRating))}
              </div>
              <div className="stat-label">Průměrné hodnocení</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{totalReviews}</div>
              <div className="stat-label">Recenzí na Google</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Spokojených zákazníků</div>
            </div>
          </div>
        </div>

        <div className="reviews-carousel">
          <div className="carousel-container">
            <button className="carousel-btn prev" onClick={prevReview}>
              <span>‹</span>
            </button>

            <div className="reviews-slider">
              <div 
                className="reviews-track"
                style={{ transform: `translateX(-${currentReview * 100}%)` }}
              >
                {reviews.map((review, index) => (
                  <div key={index} className="review-card">
                    <div className="review-header">
                      <div className="reviewer-avatar">
                        <span>{review.initials}</span>
                      </div>
                      <div className="reviewer-info">
                        <h4>{review.name}</h4>
                        <div className="review-stars">
                          {renderStars(review.rating)}
                        </div>
                        <span className="review-course">{review.course}</span>
                      </div>
                    </div>
                    <div className="review-content">
                      <div className="quote-icon">"</div>
                      <p>{review.text}</p>
                    </div>
                    <div className="review-source">
                      <span className="google-icon">🌟</span>
                      <span>Recenze z Google</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button className="carousel-btn next" onClick={nextReview}>
              <span>›</span>
            </button>
          </div>

          <div className="carousel-dots">
            {reviews.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentReview ? 'active' : ''}`}
                onClick={() => handleReviewSelect(index)}
              />
            ))}
          </div>
        </div>

        <div className="reviews-cta">
          <div className="cta-content">
            <h3>Připojte se k našim spokojeným absolventům</h3>
            <p>Získejte řidičský průkaz s autoškoulou, které důvěřují stovky řidičů</p>
            <div className="cta-buttons">
              <button className="btn btn-primary" onClick={handleContactClick}>
                Přihlásit se na kurz
              </button>
              <a 
                href="https://www.google.com/search?q=autoškola+příkaský+recenze" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-secondary"
              >
                <span className="google-icon">🌟</span>
                Více recenzí na Google
              </a>
            </div>
          </div>
        </div>

        <div className="trust-indicators">
          <div className="indicator">
            <div className="indicator-icon">🏆</div>
            <h4>10+ let zkušeností</h4>
            <p>Dlouholetá tradice a zkušenosti</p>
          </div>
          <div className="indicator">
            <div className="indicator-icon">✅</div>
            <h4>Vysoká</h4>
            <p>Úspěšnost u zkoušek</p>
          </div>
          <div className="indicator">
            <div className="indicator-icon">🚗</div>
            <h4>Moderní vozový park</h4>
            <p>Škoda Fabia a Dacia Duster</p>
          </div>
          <div className="indicator">
            <div className="indicator-icon">👨‍🏫</div>
            <h4>Osobní přístup</h4>
            <p>Individuální výuka pro každého</p>
          </div>
        </div>
      </div>

      {/* Background decorations */}
      <div className="reviews-background">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>
      </div>
    </div>
  )
}

export default ReviewsSection